export default __webpack_public_path__ + "static/media/quotes-end.e455379a.svg";